export default __webpack_public_path__ + "static/media/GuyAnimation4.60ea8143.svg";